export const FETCH_AD_HOC_TYPES_REQUEST = 'FETCH_AD_HOC_TYPES_REQUEST';
export const FETCH_AD_HOC_TYPES_SUCCESS = 'FETCH_AD_HOC_TYPES_SUCCESS';
export const FETCH_AD_HOC_TYPES_FAILED = 'FETCH_AD_HOC_TYPES_FAILED';

export const FETCH_AD_HOC_TYPES_BY_ID_REQUEST = 'FETCH_AD_HOC_TYPES_BY_ID_REQUEST';
export const FETCH_AD_HOC_TYPES_BY_ID_SUCCESS = 'FETCH_AD_HOC_TYPES_BY_ID_SUCCESS';
export const FETCH_AD_HOC_TYPES_BY_ID_FAILED = 'FETCH_AD_HOC_TYPES_BY_ID_FAILED';
export const RESET_AD_HOC_TYPES = 'RESET_AD_HOC_TYPES';

export const FETCH_PRICING_TYPES_REQUEST = 'FETCH_PRICING_TYPES_REQUEST';
export const FETCH_PRICING_TYPES_SUCCESS = 'FETCH_PRICING_TYPES_SUCCESS';
export const FETCH_PRICING_TYPES_FAILED = 'FETCH_PRICING_TYPES_FAILED';

export const FETCH_RULESETS_REQUEST = 'FETCH_RULESETS_REQUEST';
export const FETCH_RULESETS_SUCCESS = 'FETCH_RULESETS_SUCCESS';
export const FETCH_RULESETS_FAILED = 'FETCH_RULESETS_FAILED';

export const FETCH_TAX_RULESETS_REQUEST = 'FETCH_TAX_RULESETS_REQUEST';
export const FETCH_TAX_RULESETS_SUCCESS = 'FETCH_TAX_RULESETS_SUCCESS';
export const FETCH_TAX_RULESETS_FAILED = 'FETCH_TAX_RULESETS_FAILED';

export const FETCH_RULESET_REQUEST = 'FETCH_RULESET_REQUEST';
export const FETCH_RULESET_SUCCESS = 'FETCH_RULESET_SUCCESS';
export const FETCH_RULESET_FAILED = 'FETCH_RULESET_FAILED';

export const FETCH_DELETE_RULESET_REQUEST = 'FETCH_DELETE_RULESET_REQUEST';
export const FETCH_DELETE_RULESET_SUCCESS = 'FETCH_DELETE_RULESET_SUCCESS';
export const FETCH_DELETE_RULESET_FAILED = 'FETCH_DELETE_RULESET_FAILED';

export const FETCH_ACCOUNTING_TYPES_REQUEST = 'FETCH_ACCOUNTING_TYPES_REQUEST';
export const FETCH_ACCOUNTING_TYPES_SUCCESS = 'FETCH_ACCOUNTING_TYPES_SUCCESS';
export const FETCH_ACCOUNTING_TYPES_FAILED = 'FETCH_ACCOUNTING_TYPES_FAILED';

export const FETCH_CREATE_RULESET_REQUEST = 'FETCH_CREATE_RULESET_REQUEST';
export const FETCH_CREATE_RULESET_SUCCESS = 'FETCH_CREATE_RULESET_SUCCESS';
export const FETCH_CREATE_RULESET_FAILED = 'FETCH_CREATE_RULESET_FAILED';

export const FETCH_ADD_RULESET_REQUEST = 'FETCH_ADD_RULESET_REQUEST';
export const FETCH_ADD_RULESET_SUCCESS = 'FETCH_ADD_RULESET_SUCCESS';
export const FETCH_ADD_RULESET_FAILED = 'FETCH_ADD_RULESET_FAILED';

export const FETCH_UPDATE_RULESET_REQUEST = 'FETCH_UPDATE_RULESET_REQUEST';
export const FETCH_UPDATE_RULESET_SUCCESS = 'FETCH_UPDATE_RULESET_SUCCESS';
export const FETCH_UPDATE_RULESET_FAILED = 'FETCH_UPDATE_RULESET_FAILED';

export const SET_EXIT = 'SET_EXIT';
export const CHANGE_POSITION = 'CHANGE_POSITION';

export const RESET_ONBOARDING = 'RESET_ONBOARDING';
export const RESET_CURRENT_RULESET = 'RESET_CURRENT_RULESET';
export const FETCH_RULE_SUCCESS = 'FETCH_RULE_SUCCESS';

export const FETCH_UPDATE_RULE_BY_ID_SUCCESS = 'FETCH_UPDATE_RULE_BY_ID_SUCCESS';
export const FETCH_UPDATE_RULES_SUCCESS = 'FETCH_UPDATE_RULES_SUCCESS';
export const FETCH_REMOVE_RULE_SUCCESS = 'FETCH_REMOVE_RULE_SUCCESS';
export const FETCH_UPDATE_RULESET_INFO_SUCCESS = 'FETCH_UPDATE_RULESET_INFO_SUCCESS';

export const FETCH_RULESET_VEHICLE_GROUPS_REQUEST = 'FETCH_RULESET_VEHICLE_GROUPS_REQUEST';
export const FETCH_RULESET_VEHICLE_GROUPS_SUCCESS = 'FETCH_RULESET_VEHICLE_GROUPS_SUCCESS';
export const FETCH_RULESET_VEHICLE_GROUPS_FAILED = 'FETCH_RULESET_VEHICLE_GROUPS_FAILED';

export const FETCH_ADD_TAX_RULESET_REQUEST = 'FETCH_ADD_TAX_RULESET_REQUEST';
export const FETCH_ADD_TAX_RULESET_SUCCESS = 'FETCH_ADD_TAX_RULESET_SUCCESS';
export const FETCH_ADD_TAX_RULESET_FAILED = 'FETCH_ADD_TAX_RULESET_FAILED';

export const FETCH_SKUS_ASSOCIATED_REQUEST = 'FETCH_SKUS_ASSOCIATED_REQUEST';
export const FETCH_SKUS_ASSOCIATED_SUCCESS = 'FETCH_SKUS_ASSOCIATED_SUCCESS';
export const FETCH_SKUS_ASSOCIATED_FAILED = 'FETCH_SKUS_ASSOCIATED_FAILED';

export const FETCH_TAX_RULESET_BY_ID_REQUEST = 'FETCH_TAX_RULESET_BY_ID_REQUEST';
export const FETCH_TAX_RULESET_BY_ID_SUCCESS = 'FETCH_TAX_RULESET_BY_ID_SUCCESS';
export const FETCH_TAX_RULESET_BY_ID_FAILED = 'FETCH_TAX_RULESET_BY_ID_FAILED';

export const FETCH_DELETE_TAX_RULESET_REQUEST = 'FETCH_DELETE_TAX_RULESET_REQUEST';
export const FETCH_DELETE_TAX_RULESET_SUCCESS = 'FETCH_DELETE_TAX_RULESET_SUCCESS';
export const FETCH_DELETE_TAX_RULESET_FAILED = 'FETCH_DELETE_TAX_RULESET_FAILED';

export const FETCH_CREATE_TAX_RULESET_REQUEST = 'FETCH_CREATE_TAX_RULESET_REQUEST';
export const FETCH_CREATE_TAX_RULESET_SUCCESS = 'FETCH_CREATE_TAX_RULESET_SUCCESS';
export const FETCH_CREATE_TAX_RULESET_FAILED = 'FETCH_CREATE_TAX_RULESET_FAILED';

export const FETCH_UPDATE_TAX_RULESET_REQUEST = 'FETCH_UPDATE_TAX_RULESET_REQUEST';
export const FETCH_UPDATE_TAX_RULESET_SUCCESS = 'FETCH_UPDATE_TAX_RULESET_SUCCESS';
export const FETCH_UPDATE_TAX_RULESET_FAILED = 'FETCH_UPDATE_TAX_RULESET_FAILED';

export const FETCH_REMOVE_TAXES = 'FETCH_REMOVE_TAXES';
export const FETCH_UPDATE_TAXES = 'FETCH_UPDATE_TAXES';

export const FETCH_RESET_TAX_RULESET = 'FETCH_RESET_TAX_RULESET';

export const FETCH_UPDATE_TAXES_ORDER = 'FETCH_UPDATE_TAXES_ORDER';
export const RESET_CURRENT_TAX_RULESET = 'RESET_CURRENT_TAX_RULESET';

export const FETCH_UPDATE_TAX_RULESET_INFO = 'FETCH_UPDATE_TAX_RULESET_INFO';
